import React from 'react';

const PixQrCode: React.FC = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
    <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
      <h1 className="text-2xl font-bold text-gray-900">Pagamento Pix</h1>
      <p className="mt-2 text-gray-600">Nenhum pagamento ativo para exibicao.</p>
    </div>
  </div>
);

export default PixQrCode;
